// import libs
import React from "react";
import { Router, Switch } from "react-router-dom";
import { Route, Redirect } from "react-router";
import createBrowserHistory from "history/createBrowserHistory";

import Login from "../system/containers/Login";

// import components
import routes from "./routes";
import PrivateRoute from "../system/routes/Private";
import PublicRoute from "../system/routes/Public";

import env from "../config/config";

const history = createBrowserHistory();

const Routes = () => (
  <Router history={history}>
    <Switch>
      <Route exact path={"/"} render={() => <Redirect to={"/login"} />} />
      {routes.map((route, i) => {
        if (route.auth) {
          return <PrivateRoute key={i} {...route} />;
        }
        return <PublicRoute key={i} {...route} />;
      })}
    </Switch>
  </Router>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/routes/index.jsx